import { Button, Group, Menu } from '@mantine/core';
import { Icon } from '#shared/components';

import classes from './AddItemButton.module.css';

type Props = {
  children: React.ReactNode;
  onClickButton?: () => void | Promise<void>;
};

export const AddItemButton = ({ onClickButton, children }: Props) => {
  return (
    <Group gap={0} wrap="nowrap">
      <Button className={classes.button} onClick={onClickButton} size="xs">
        {children}
      </Button>
      <Menu position="bottom-end" shadow="lg" withinPortal>
        <Menu.Target>
          <Button className={classes.menuControl} size="xs">
            <Icon name="chevron-down" size={14} />
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            classNames={{ itemSection: classes.itemSection }}
            leftSection={<Icon name="bookmark" size={22} strokeWidth={1.2} />}
            onClick={onClickButton}
          >
            Add Bookmark
          </Menu.Item>
          <Menu.Item
            classNames={{ itemSection: classes.itemSection }}
            leftSection={<Icon name="notebook" size={22} strokeWidth={1.2} />}
          >
            Add Note
          </Menu.Item>
          <Menu.Item
            classNames={{ itemSection: classes.itemSection }}
            leftSection={<Icon name="image" size={21} strokeWidth={1.3} />}
          >
            Add Image
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
